import Carousel from './Carousel';
import withLocale from '../IntlProvider/withLocale';
export default withLocale([])(Carousel);